/** @format */

export { hasImpressum } from './helpers/language';
export {
    hasTotalsExcludingTax,
    hasModernSlaveryStatement,
    hasPlatformTermsOfUse,
} from './helpers/market';
export { MarketContext, type MarketContextProps } from './context';
export * from './config/markets';
export {
    marketsWithTotalsExcludingTax,
    marketsWithModernSlaveryStatement,
    marketsWithPlatformTermsOfUse,
} from './config/market';
